import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { SetState } from "source/app/services/UI/State/SetState";
import {
    UpdateNodeAsync,
    UpdateNodeInDatabaseFromClientAsync,
} from "source/app/services/Workflows/ChangeData/UpdateNodeAsync";

export async function SaveNodeChangesAsync(
    shouldSkipWriteToDb: boolean = false
) {
    const state = ReadState<IRootNodeFormState>(
        ESharedFunction.RootNodeName_state
    )!;

    SetState<IRootNodeFormState>(ESharedFunction.RootNodeName_state, {
        ...state,
        showEditControls: false,
    });

    const changes: Partial<IWorkflowNode> = {
        name: state.newName,
        maxchildren: state.newMaxChildren,
        sortorder: state.newSortOrder,
        options: state.newOptions,
    };

    if (shouldSkipWriteToDb) {
        return;
    }

    await UpdateNodeAsync(state.rootNode, changes);
}

export async function QuickSaveNodeChangesAsync() {
    const state = ReadState<IRootNodeFormState>(
        ESharedFunction.RootNodeName_state
    )!;

    SetState<IRootNodeFormState>(ESharedFunction.RootNodeName_state, {
        ...state,
        showEditControls: true,
    });

    const changes: Partial<IWorkflowNode> = {
        name: state.newName,
        maxchildren: state.newMaxChildren,
        sortorder: state.newSortOrder,
        options: state.newOptions,
    };

    await WithAnimatedProgressBarAsync(() =>
        UpdateNodeInDatabaseFromClientAsync(state.rootNode, changes)
    );
}
